<template>
  <transition name="router-anim">
    <div class="registration">

      <div class="card" id="">
        <header class="card-header ">
          <img class="" :src="$t('logoUrl')" alt="logo" style="height:35px; margin: 5px auto;">
        </header>


        <div class="card-content">
          <div class="has-text-centered">
                      <div style="position: relative; top:0;left:0;width:200px; min-width:200px;margin: 0 auto;">
          <img src="https://savemenu.ru/_public/img/poster_400x400.png" alt="" style="width:100%;margin-bottom: 2rem;position: relative; top:0;left:0;">

          </div>
            <h3 class="title is-4">{{ $t('SignupPosterDialog.heading') }}</h3>
            <h3 class="title is-6">Интеграция SaveМеню + Poster позволяет</h3>
            <div class="has-text-left" style="font-size:16px;max-width:500px;margin-left:auto;margin-right:auto;">
              <p>- Перенести все позиции меню</p>
              <p>- Поддерживать синхронизацию Poster => SaveМеню</p>
              <p>- Получать заказы через SaveМеню на терминал Poster</p>
              <p>- Применять скидки, назначенные в Poster</p>
            
              <b-notification style="padding: 0.5rem 2.5rem 0.5rem 1.5rem;margin: 1.25rem 0;" :closable="false">Вы можете включать\выключать синхронизацию по необходимости в разделе Настройки - Интеграции.</b-notification>
            </div>
          </div>

        <footer class="has-text-centered" style="position: relative">
          <button class="button is-green" :class="{'is-loading':isLoading}" style="min-width:130px;margin-top: 2rem;color:white!important;"
            @click="goToPoster()">{{ !isLoading?$t('SignupPosterDialog.yes'):"" }}</button>
          <button class="button" :class="{'is-loading':isLoading}" style="min-width:130px;margin-top: 2rem;border:none; color: gray;"
            @click="skip()">{{ !isLoading?$t('SignupPosterDialog.skip'):"" }}</button>
        </footer>

      </div>
    </div>
    </div>
  </transition>
</template>

<script>
import {
  mapActions,
  mapGetters
} from "vuex";
import _ from "underscore";
import api from '../api'

const locales = {
  en: {
    cash: "Cash",
    pickup: "Pick up",
    delivery: "Delivery",
    address: "Address",
    name: "Name",
    email: "Email",
    phone: "Phone"
  },
  ru: {
    cash: "Наличные",
    pickup: "Самовывоз",
    delivery: "Доставка",
    address: "Адрес",
    name: "Имя",
    email: "Email",
    phone: "Телефон"
  },
}

export default {
  components: {},

  computed: _.extend({},
    mapGetters({
      info: "getPlaceInfo"
    }), {}
  ),

  data() {
    return {
      isLoading: false,
      isChecking: false,
      chosenUrl: "",
      checkingResponse: "Проверить",
      statusMessage: "",
      populated: false,
      input: {},
      messageSeen: false
    };
  },
  methods: _.extend({}, mapActions(["populatePlaceInfo", "updatePlaceInfo"]), {
    goToPoster() {
      this.$buefy.dialog.confirm({
        message: this.$t('Poster.dialogConnectPosterMessage'),
        title: this.$t('Poster.title'),
        type: 'is-success',
        confirmText: this.$t('Dashboard.yes'),
        cancelText: this.$t('Dashboard.back'),
        onConfirm: () => {
          this.$ma.trackEvent({
            category: 'event',
            action: 'Connection with Poster started',
            label: null,
            value: null
          })

          window.open(`https://joinposter.com/api/auth?application_id=1378&redirect_uri=https://create.savemenu.ru/poster&response_type=code`, "_self")
        },
        onCancel: () => {
          this.$ma.trackEvent({
            category: 'event',
            action: 'Connection with Poster cancelled',
            label: null,
            value: null
          });
        }
      })
    },
    skip () {
      this.$ma.trackEvent({
            category: 'event',
            action: 'Connection with Poster skipped',
            label: null,
            value: null
          })
      let nextStep = "/signup_3"
      this.$router.replace(this.$route.query.redirect || nextStep);
  },
  }),
  mounted() {
    // window.onbeforeunload = function () {
    //   return "Are you sure you want to exit?";
    // };
    this.$title = this.$t('title') + " | " + this.$t('Signup.title')
    this.$cognitoAuth.refreshSession(options => {
      this.populatePlaceInfo(options).then(() => {
        this.populated = true
      })
    })

  this.$ma.trackEvent({
      category: 'event',
      action: 'Page viewed: ' + this.$route.fullPath,
      label: null,
      value: null
    })

  }
}
</script>

<style scoped>
html {
    overflow: hidden;
}
body {
    background: #fff!important;
  }

.form{
  /* width: 60%; */
  margin: 2rem auto 2rem;
}

.field-label {
flex-grow: 3;
}


.card {
  /* min-height: 70vh; */
}


.check {
  border-color: #27ab83 !important;
}

.check::before {
  background-color: #27ab83 !important;
}

.b-radio.radio input[type="radio"]:checked + .check {
  border-color: #27ab83!important;
}

@media screen and (min-width:768px) {
 .card-content {
    margin-top: 2vh;
  }
}
@media screen and (max-width:768px) {
  #signup1 .box {
      padding: 1rem 0rem 2rem;
      box-shadow: none;
  }

  .form{
      /* width: 80%; */
      margin: 1.5rem auto 2rem;

  }
  .registration .field:not(:last-child) {
      margin-bottom: 0.75rem;
  }
  /* .registration .notification {
    margin-left: 1rem;
    margin-right: 1rem;
    margin-bottom: 0;
    padding: 0.5rem 2.5rem 0.5rem 1.5rem;
  } */

  .label:not(:last-child) {
    margin-bottom: 0;
  }


}
.free {
  border-color: #49c161 !important;
}

.not-free {
  border-color: #ff8f00 !important;
}

button:focus, .button.is-focused {
    border-color: #9f9f9f;
    box-shadow: none;
}

.control.is-loading::after {
  z-index: 11;
}
</style>

